<div class="page-title-area">
  <div class="d-table">
      <div class="d-table-cell">
          <div class="container">
              <div class="page-title-text">
                  <h2>Contact Us</h2>
                  <ul>
                      <li><a routerLink="/">Home</a></li>
                      <li><i class="icofont-simple-right"></i></li>
                      <li>Contact Us</li>
                  </ul>
              </div>
          </div>
      </div>
  </div>
</div>

<div class="company-details-area pt-100">
  <div class="container">
      <div class="row">
          <div class="col-lg-8">
              <div class="company-details-item">
                  <div class="company-details-logo">
                      <img src="assets/img/home/trepez_logo_2.png" alt="Trepez">

                      <div class="company-logo-inner">
                          <h3>Trepez</h3>
                          <p><i class="icofont-location-pin"></i>60 Ikot-Ekpene Rod,Uyo!</p>
                      </div>
                  </div>

                  <!-- <div class="company-details-share">
                      <span>Share:</span>

                      <ul>
                          <li><a href="https://web.facebook.com/" target="_blank"><i class="icofont-facebook"></i></a></li>
                          <li><a href="https://www.twitter.com/@trepez_link" target="_blank"><i class="icofont-twitter"></i></a></li>
                          <li><a href="https://www.instagram.com/@trepez_link" target="_blank"><i class="icofont-instagram"></i></a></li>
                          <li><a href="https://www.linkedin.com/" target="_blank"><i class="icofont-linkedin"></i></a></li>
                      </ul>
                  </div> -->

                  <div class="company-details-find">
                      <h3>Find Us:</h3>

                      <ul>
                          <li><a href="#" target="_blank"><i class="icofont-web"></i> trepez.com</a></li>
                          <li><a href="https://web.facebook.com/" target="_blank"><i class="icofont-facebook"></i> trepez.com</a></li>
                          <li><a href="https://www.instagram.com/@trepez_link" target="_blank"><i class="icofont-instagram"></i>@trepez_link</a></li>
                          <!-- <li><a href="https://web.facebook.com/My3clickcom-101656855371176" target="_blank"><i class="icofont-facebook"></i> trepez.com</a></li> -->
                          <!-- <li><a href="https://www.linkedin.com/" target="_blank"><i class="icofont-linkedin"></i> trepez.com</a></li> -->
                          <li><a href="https://www.twitter.com/@trepez_link" target="_blank"><i class="icofont-twitter"></i>@trepez_link</a></li>
                          <!-- <li><a href="#" target="_blank"><i class="icofont-google-plus"></i> trepez.com</a></li> -->
                      </ul>
                  </div>

                  <div class="company-details-description">
                      <h3>Description</h3>
                      <p><span class="text-bold">trepez</span> is an independent platform for connecting professional and reliable services.
                       We go through the hassle for your convenience. With thousands of service providers in our database, users are
                       a few clicks away from quality service.
                      </p>
                  </div>

                  <!-- <div class="text-center">
                      <a class="job-details-btn" routerLink="/create-account">Apply Now</a>
                  </div> -->
              </div>
          </div>

          <div class="col-lg-4">
              <div class="company-details-item">
                  <div class="single-resume-category">
                      <h3>Service Categories</h3>

                      <ul>
                          <li><a routerLink="/">Logistics</a></li>
                          <li><a routerLink="/">Technicians & Mechanics</a></li>
                          <li><a routerLink="/">Hair & Beauty Salons</a><span></span></li>
                          <li><a routerLink="/">Graphics & Photography</a><span></span></li>
                          <li><a routerLink="/">General Artisans</a><span></span></li>
                          <li><a routerLink="/">Techs & ICT</a><span></span></li>
                      </ul>
                  </div>

                  <div class="single-resume-category single-resume-types">
                      <h3>Office Locations</h3>

                      <ul>
                          <li><a href="#">60 Ikot-Ekpene Road,Uyo, Akwa Ibom State</a></li>
                          <!-- <li><a href="#">Washington</a><span>(5)</span></li>
                          <li><a routerLink="/">Chicago</a><span>(3)</span></li>
                          <li><a routerLink="/">Houston</a><span>(1)</span></li>
                          <li><a routerLink="/">Los Angeles</a><span>(0)</span></li> -->
                      </ul>
                  </div>
              </div>
          </div>
      </div>
  </div>
</div>

